import { Typography, Paper, Box, Breadcrumbs, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { FC, PropsWithChildren } from 'react'

interface BreadCrumbItem {
  label: string
  href: string
}

interface MainContentHeaderProps extends PropsWithChildren {
  title?: string | React.ReactNode
  buttons?: React.ReactNode
  breadcrumbs?: BreadCrumbItem[]
}

export const MainContentHeader: FC<MainContentHeaderProps> = ({
  title,
  children,
  buttons,
  breadcrumbs,
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        padding: '16px 24px',
        borderRadius: 0,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        zIndex: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {breadcrumbs ? (
          <Breadcrumbs>
            {breadcrumbs.map((breadcrumb, index) => {
              const isLast = index === breadcrumbs.length - 1
              return isLast ? (
                <Typography key={breadcrumb.href} sx={{ color: 'text.primary' }} variant="h6">
                  {breadcrumb.label}
                </Typography>
              ) : (
                <Link
                  key={breadcrumb.href}
                  component={RouterLink}
                  to={breadcrumb.href}
                  variant="h6"
                >
                  {breadcrumb.label}
                </Link>
              )
            })}
          </Breadcrumbs>
        ) : (
          title && (
            <Typography variant="h6" component="h1" fontWeight="600" color="text.primary">
              {title}
            </Typography>
          )
        )}
        {buttons && <Box sx={{ display: 'flex', gap: 1 }}>{buttons}</Box>}
      </Box>
      {children}
    </Paper>
  )
}
